import { IoArrowForward, IoFilterOutline } from "react-icons/io5";
import EventPageItem from "./EventPageItem";
import { Button, Dropdown } from "flowbite-react";
import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import EventsService from "../../services/EventsService";
import Helpers from "../../utils/Helpers";
import _ from "lodash";
import ButtonLoading from "../../components/ButtonLoading";

const cities = [
    {name: 'Abidjan', code: 'ABIDJAN'},
    {name: 'Yamoussoukro', code: 'YAKRO'},
    {name: 'Bouaké', code: 'BOUAKE'},
    {name: 'San-Pédro', code: 'SANPEDRO'},
    {name: 'Daloa', code: 'Daloa'},
];

const EventsSearch = () => {
    const EVENTS_PER_PAGE = 10;
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useSearchParams();
    const [events, setEvents] = useState([]);
    const [categories, setCategories] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(null);
    const [searchParams, setSearchParams] = useState({
        category: parseInt(searchQuery.get('category') || '0'),
        city: searchQuery.get('city'),
        date: searchQuery.get('date'),
        page: searchQuery.get('page')
    });

    const getEvents = (onlyEvent=false) => {
        const promises = [EventsService.searchEvent(searchParams)];
		
        setLoading('get-events');
        !onlyEvent && promises.push(EventsService.getCategories());

		Promise.all(promises)
            .then(response => {
                setEvents(response[0].events);
                !onlyEvent && setCategories(response[1].categories);
            })
            .catch(err => console.log(err))
            .finally(() => setLoading(null));
    
        setSearchQuery(_.pickBy(searchParams, x => !!x));
	};

    useEffect(() => {
        getEvents(categories.length);
    }, [searchParams]);

    return (
        <>
        <section className={`pt-10 lg:pt-20 pb-20 bg-gray-900`}>
            <div className={`max-w-screen-2xl mx-auto px-10 md:px-20 flex flex-col lg:flex-row md:items-center gap-5`}>
                <h1 className={`text-4xl text-gray-100 font-bold max-w-none lg:max-w-xs text-center lg:text-left`}>
                    Que <span className={`text-orange-500`}>recherchez</span> vous ?
                </h1>
                <div className={`bg-white min-h-[110px] rounded-md flex-1 flex flex-col md:flex-row gap-4 md:gap-16 p-5 md:p-10`}>
                    <div className={`p-3 md:p-0 border md:border-0 border-neutral-100 rounded-md`}>
                        <span className={`text-base text-gray-500 block`}>Quoi ?</span>
                        <Dropdown
                            theme={{ floating: { content: 'w-[200px]' }}}
                            renderTrigger={() => (
                                <button className={`text-lg text-gray-700 cursor-pointer text-left`}>
                                    {
                                        searchParams.category
                                            ? (categories.find(x => x.id === searchParams.category)?.label || 'Selectionnez une catégorie')
                                            : 'Selectionnez une catégorie'
                                    }
                                </button>
                            )}
                        >
                            {categories.map(item => (
                                <Dropdown.Item
                                    key={item.id}
                                    onClick={() => setSearchParams(state => ({...state, category: item.id, page: null}))}
                                >{item.label}</Dropdown.Item>
                            ))}
                        </Dropdown>
                        
                    </div>
                    <div className={`p-3 md:p-0 border md:border-0 border-neutral-100 rounded-md`}>
                        <span className={`text-base text-gray-500 block`}>Où ?</span>
                        <Dropdown
                            theme={{ floating: { content: 'w-[200px]' }}}
                            renderTrigger={() => (
                                <button className={`text-lg text-gray-700 cursor-pointer text-left`}>
                                    {
                                        searchParams.city
                                            ? cities.find(x => x.code === searchParams.city)?.name
                                            : 'Selectionnez une ville'
                                    }
                                </button>
                            )}
                        >
                            {cities.map(item => (
                                <Dropdown.Item
                                    key={item.code}
                                    onClick={() => setSearchParams(state => ({...state, city: item.code, page: null}))}
                                >{item.name}</Dropdown.Item>
                            ))}
                        </Dropdown>
                        
                    </div>
                    <div className={`p-3 md:p-0 border md:border-0 border-neutral-100 rounded-md`}>
                        <span className={`text-base text-gray-500 block`}>Quand ?</span>
                        <input
                            type="date"
                            id="date-pick"
                            className={`p-0 outline-none mt-1 border-0 text-gray-700`}
                            onChange={evt => setSearchParams(state => ({...state, date: evt.target.value, page: null}))}
                        />
                    </div>
                    <div className="self-center ml-auto w-full md:w-auto">
                        <Button
                            // onClick={() => goToSearch()}
                            disabled={true}
                            className={`bg-orange-500 hover:!bg-orange-600 h-12 w-full md:w-auto`}
                        >CHERCHER</Button>
                    </div>
                </div>
            </div>
        </section>
        <section className={`py-20`}>
            <div className={`max-w-screen-2xl mx-auto px-10 md:px-20`}>
                <div className={`flex items-center`}>
                    <div className={``}>
                        <h4 className={`text-gray-500 text-xs md:text-sm uppercase`}>Recherche</h4>
                        <h1 className={`text-gray-800 text-3xl md:text-5xl font-bold`}>Resultats de la recherche</h1>
                    </div>
                    <Button
                        className={`bg-orange-200 hover:!bg-orange-300 text-orange-500 h-10 md:h-12 px-1 ml-auto shrink-0`}
                        onClick={() => setSearchParams({})}
                    >
                        Réinitialiser <IoFilterOutline size={18} className={`ml-2`} />
                    </Button>
                </div>
                <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-12 gap-8`}>
                    {!loading || ((searchParams.page || 1) > 1 && events.length) ? (
                        events.map(item => (
                            <Link to={`/events/${item.id}`} key={item.id}>
                                <EventPageItem item={item} />
                            </Link>
                        ))
                    ) : null}
                    {loading && (!events.length || (searchParams.page || 1) === 1) ? (
                        [1,2,3,4,5,6].map(item => <div key={item} className={`h-[450px] bg-neutral-200 animate-pulse rounded-md`}></div>)
                    ) : null}
				</div>
                {(events.length % EVENTS_PER_PAGE) === 0 ? (
                    <div className={`mt-10 flex justify-center`}>
                        <ButtonLoading
                            className={`bg-orange-500 hover:!bg-orange-600 h-11`}
                            onClick={() => setSearchParams(state => ({...state, page: (state.page || 0) + 1}))}
                            isProcessing={loading}
                        >Afficher plus d'évènements</ButtonLoading>
                    </div>
                ) : null}
            </div>
        </section>
        </>
    );
};

export default EventsSearch;